import React, { FC } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EditCategoryForm from './edit-category-form.component';

type EditCategoryDialogProps = {
    dialogOpen: boolean;
    onCloseDialog: () => void;
    categoryToEdit: { _id: string; name: string };
    onEditCategory: (category: { _id: string; name: string }) => void;
};
const EditCategoryDialog: FC<EditCategoryDialogProps> = ({
    dialogOpen,
    onCloseDialog,
    categoryToEdit,
    onEditCategory,
}: EditCategoryDialogProps) => {
    const { t: translate } = useTranslation('actions-materials');
    return (
        <Dialog fullWidth maxWidth="sm" open={dialogOpen}>
            <DialogTitle>{translate('actions-materials:EDIT_CATEGORY')}</DialogTitle>
            <EditCategoryForm
                onCloseDialog={onCloseDialog}
                categoryToEdit={categoryToEdit}
                onEditCategory={onEditCategory}
            />
        </Dialog>
    );
};

export default EditCategoryDialog;
